import React from 'react'
import LogoSquare from '../images/logosmall.png'

function LogoSmall(props) {
  return <img src={LogoSquare} alt="logo" {...props} />
}

export default LogoSmall
